"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
var IconButton_1 = __importDefault(require("./IconButton"));
var CircleIconButton = (0, material_1.styled)(IconButton_1.default, { shouldForwardProp: (0, general_1.omitProps)('hasRedDot') })(function (_a) {
    var _b, _c;
    var theme = _a.theme, hasRedDot = _a.hasRedDot;
    return ({
        padding: 3,
        lineHeight: '20px',
        borderRadius: '50%',
        backgroundColor: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
        color: theme.palette.common.white,
        '&.MuiIconButton-sizeMedium': {
            height: 20,
            width: 20,
        },
        '&:hover': {
            background: '#879DA9',
            color: theme.palette.common.white,
        },
        svg: {
            '&:hover': {
                color: theme.palette.common.white,
            },
        },
        position: 'relative',
        '&:after': hasRedDot && {
            content: '""',
            display: 'block',
            position: 'absolute',
            width: theme.spacing(1),
            height: theme.spacing(1),
            background: (_c = theme.palette.red) === null || _c === void 0 ? void 0 : _c.main,
            top: 0,
            right: 0,
            borderRadius: '50%',
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(CircleIconButton, {
    color: 'neutral',
});
